import * as core from '../../../../../../../core'

import { query } from './outcome-explore-employees.query'

export const RESOURCE = {
  payload: {
    alias: 'summit.outcome-explore-employees',
    description:
      'Displays employees information about the currently focused outcome, if there is one',
    name: 'Summit - Outcome Explore Employees',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
